<script>
// 添加施工现场
import UploadWithPreview from "@/views/widgets/upload-files/upload-with-preview";
import {addSiteDescription} from "@/service";
import { alertError, successMsg } from "@/helpers/swal";
import i18n from "@/i18n";

export default {
  props: {
    title: {
      type: String,
      default: i18n.global.t('page.initial_status')
    },
    workId: {
      type: [String, Number],
      default: ''
    },
  },
  data () {
    return {
      showModal: false,
      form: {},
      saveDisabled: false,
    }
  },
  methods: {
    open() {
      this.formInit()
      this.showModal = true
    },
    formInit() {
      this.form = {
        work_order: this.workId,
        content: '',
        attachment:[],
      }
    },
    pictureChange(ids) {
      this.form.attachment = ids
    },
    save() {
      if (this.form.attachment.length == 0) {
        alertError(this.$t('base.prompt'), this.$t('page.PleaseUploadAttachment'))
        return;
      }
      this.saveDisabled = true
      this.showModal = false
      //现场情况说明发起请求
      addSiteDescription(this.form).then(()=>{
        this.saveDisabled = false
          successMsg(this.$t('page.ConstructionRecordsWereSuccessfullyAdded'))
        this.showModal = false
        this.$emit('complete')
      })
    }
  },
  components: {
    UploadWithPreview,
  }
}
</script>
<template>
  <b-modal
      v-model="showModal"
      hide-footer
      :title="title"
      class="v-modal-custom"
      body-class="p-0"
      scrollable
  >
    <div class="modal-body border-top">
      <div class="mb-3">
        <label class="form-label" for="meta-keywords-input">
          {{ $t('page.repair-request.RecordDescription')}}
        </label>
        <b-form-textarea v-model="form.content"></b-form-textarea>
      </div>
      <div class="mb-3">
        <label class="form-label" for="meta-keywords-input">{{this.$t('page.attachment')}}</label>
        <upload-with-preview
            v-if="showModal"
            :value="form.attachment"
            input-id="uploadWorkSiteAttachment"
            :multiple="true"
            preview-type="thumb"
            filename-prefix="wo"
            @changed="pictureChange"
        ></upload-with-preview>
      </div>
    </div>
    <div class="modal-footer v-modal-footer">
      <b-button type="button" variant="light" @click="showModal = false">{{this.$t('base.cancel')}}
      </b-button>
      <b-button type="button" variant="primary" @click="save" :disabled="saveDisabled">{{this.$t('base.done')}}</b-button>
    </div>
  </b-modal>
</template>
